import { Dictionary, Tuple } from '@skylab-shared/types';
import { RuleViolation, ValidationContext, ValidationRule } from './validation-rule';

export type Validations = Dictionary<Tuple<ValidationRule, any>[]>;
export type ReadonlyValidations = Readonly<Validations>;

export class Validator {

    public async validateAsync(context: ValidationContext, rules: Tuple<ValidationRule, any>[]): Promise<RuleViolation[]> {
        const { sync: syncRules, async: asyncRules } = rules
            .reduce<{ async: Tuple<ValidationRule, any>[]; sync: Tuple<ValidationRule, any>[]; }>(
                (result, [{ async }], index) => (async ? result.async.push(rules[index]) : result.sync.push(rules[index]), result),
                { async: [], sync: [] }
            );

        const syncRulesViolations = this.runSyncRules(syncRules, context);
        const asyncRulesViolations = await this.runAsyncRulesAsync(asyncRules, context);

        return [...syncRulesViolations, ...asyncRulesViolations];
    }

    private async runAsyncRulesAsync(asyncRules: Tuple<ValidationRule, any>[], context: ValidationContext): Promise<RuleViolation[]> {
        const result: RuleViolation[] = [];

        for (const [validationRule, args] of asyncRules) {
            const isValid = await validationRule.validateAsync?.(context, args);
            if (!isValid) {
                result.push(this.createRuleViolation(validationRule, context));
            }
        }

        return result;
    }

    private runSyncRules(syncRules: Tuple<ValidationRule, any>[], context: ValidationContext): RuleViolation[] {
        return syncRules
            .reduce<RuleViolation[]>((result, [validationRule, args]) => {
                const isValid = validationRule.validate?.(context, args);
                return isValid
                    ? [...result]
                    : [...result, this.createRuleViolation(validationRule, context)];
            }, []);
    }

    private createRuleViolation(validationRule: ValidationRule, context: ValidationContext): RuleViolation {
        return {
            rule: validationRule,
            context,
            violation: new validationRule.violationType()
        };
    }
}
